import React, { useEffect } from 'react';
import './App.css';
import userService from './user.service.js';
import './utils/i18n';

import Hotjar from '@hotjar/browser';
import { useNavigate } from 'react-router-dom';

const siteId = 5159558;
const hotjarVersion = 6;

Hotjar.init(siteId, hotjarVersion);

const App = () => {
  const history = useNavigate();
  useEffect(() => {
    const authData = userService.getAuthData();
    if (authData.accessToken && authData.currentUserId) {
      history('/main');
    } else {
      history('/login');
    }
  }, [history]);

  return (
    <div>
      <h1>Home</h1>
    </div>
  );
};

export default App;
